export const QUOTE_STATUS = {
  ALL: 'all',
  DRAFT: 'draft',
  UNVIEWED_DRAFT_RFQ: 'unviewed_draft_rfq',
  OUTSTANDING: 'outstanding',
  EXPIRED: 'expired',
  ACCEPTED: 'accepted',
  CANCELLED: 'cancelled',
  LOST: 'lost',
  TRASH: 'trash',
} as const;
